import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Search, Star, Eye, Video, Mic2, Loader2 } from "lucide-react";
import { endpoints } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function Creators() {
  const { isAuthed } = useAuth();
  const [creators, setCreators] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  const load = (query = "") => {
    setLoading(true);
    endpoints.creatorsList(query).then((r) => setCreators(r.data?.creators || [])).finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10" data-testid="creators-page">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8">
        <div>
          <h1 className="text-4xl sm:text-5xl font-extrabold text-white flex items-center gap-3">
            <Star className="w-9 h-9 text-[#E11D2A]" /> Creators &amp; Celebrities
          </h1>
          <p className="text-slate-400 mt-2 text-base">Discover Rwandan stars, watch their content and help them earn.</p>
        </div>
        <Link to="/studio" data-testid="become-creator-link"
          className="h-11 px-6 rounded-full bg-[#E11D2A] hover:bg-[#C8121F] text-white font-bold flex items-center gap-2 self-start">
          <Mic2 className="w-4 h-4" /> {isAuthed ? "Creator Studio" : "Become a Creator"}
        </Link>
      </div>

      <form onSubmit={(e) => { e.preventDefault(); load(q); }} className="relative mb-8 max-w-md">
        <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" />
        <input value={q} onChange={(e) => setQ(e.target.value)} data-testid="creator-search-input"
          placeholder="Search creators by name…"
          className="w-full h-12 pl-11 pr-4 rounded-full bg-[#121620] border border-[#273042] text-white placeholder-slate-500 focus:border-[#E11D2A] outline-none" />
      </form>

      {loading ? (
        <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 animate-spin text-[#E11D2A]" /></div>
      ) : creators.length === 0 ? (
        <div className="text-center py-20 text-slate-400" data-testid="creators-empty">
          No creators yet. Be the first — <Link to="/studio" className="text-[#E11D2A] font-semibold">join as a creator</Link>.
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {creators.map((c) => (
            <Link key={c.id} to={`/creators/${c.slug}`} data-testid={`creator-card-${c.slug}`}
              className="group rounded-2xl bg-[#121620] border border-[#273042] p-5 hover:border-[#E11D2A]/60 transition-colors">
              <div className="flex items-center gap-4">
                <div className="w-16 h-16 rounded-full overflow-hidden bg-[#0A0C10] border border-[#273042] shrink-0 flex items-center justify-center">
                  {c.photoUrl ? <img src={c.photoUrl} alt={c.name} className="w-full h-full object-cover" />
                    : <Star className="w-7 h-7 text-[#E11D2A]" />}
                </div>
                <div className="min-w-0">
                  <h3 className="text-white font-bold text-lg truncate group-hover:text-[#E11D2A] transition-colors">{c.name}</h3>
                  <p className="text-xs text-slate-500">{c.category}</p>
                </div>
              </div>
              {c.bio && <p className="text-sm text-slate-400 mt-3 line-clamp-2">{c.bio}</p>}
              <div className="flex items-center gap-4 mt-4 text-xs text-slate-400">
                <span className="flex items-center gap-1.5"><Eye className="w-3.5 h-3.5 text-[#E11D2A]" /> {(c.totalEligibleViews || 0).toLocaleString()} views</span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
